// extracted by mini-css-extract-plugin
module.exports = {"layout":"j5","whiteBackground":"j6","content":"j7","searchContent":"j8"};